import { faRefresh, faExclamation, faCheck, faClose, faPen, faBan, faBoxArchive } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import "./style.css"

const StatusOcupante = ({value}) => {
    switch (value) {
        case 0: 
        return (
            <Tooltip title="Em digitação" placement="right">
                <div className="status_digitacao">
                    <FontAwesomeIcon icon={faPen} />
                </div>
            </Tooltip>
        )
        case 1: 
        return (
            <Tooltip title="Pendente de homologação" placement="right">
                <div className="status_pendente">
                    <FontAwesomeIcon icon={faRefresh} />
                </div>
            </Tooltip>
        );
        case 2: 
        return (
            <Tooltip title="Revisão" placement="right">
                <div className="status_revisao">
                    <FontAwesomeIcon icon={faExclamation} />
                </div>
            </Tooltip>
        );
        case 3:
        return (
            <Tooltip title="Revisão interna" placement="right">
                <div className="status_revisao">
                    <FontAwesomeIcon icon={faCheck} />
                </div>
            </Tooltip>
        );
        case 4:
        return (
            <Tooltip title="Homologado" placement="right">
                <div className="status_homologado">
                    <FontAwesomeIcon icon={faCheck} />
                </div>
            </Tooltip>
        );
        case 5: 
        return (
            <Tooltip title="Cancelado" placement="right">
                <div className="status_cancelado">
                    <FontAwesomeIcon icon={faClose} />
                </div>
            </Tooltip>
        );
        case 6:
        return (
            <Tooltip title="Inativo" placement="right">
                <div className="status_inativo">
                    <FontAwesomeIcon icon={faBan} />
                </div>
            </Tooltip>
        );
        case 7:
            return (
                <Tooltip title="Arquivado" placement="right">
                    <div className="status_arquivado">
                        <FontAwesomeIcon icon={faBoxArchive} />
                    </div>
                </Tooltip>
            );
    }
}

export { StatusOcupante };